import Vue from 'vue/dist/vue.esm';

// import Rails from 'rails-ujs';
// Rails.start();

import VueResource from 'vue-resource';
Vue.use(VueResource);

// dane Vuex
import store from '../store';

// oczekiwanie na ... ajax
import Loader from '../shared/components/loader';
// modalne okienko z komunikatem
import NoticeModal from '../shared/components/notice_modal';
import YesnoModal from '../shared/components/yesno_modal';

import CarqSelect from './components/carq_select';
import UpdateButton from './components/update_button';



document.addEventListener('DOMContentLoaded', () => {
  Vue.http.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  Vue.http.options.root = document.querySelector('#auto-vue').dataset.serverUrl;

  const app = new Vue({
    el: '#auto-vue',
    store,
    data: {
      updateUrl: ''
    },

    components: {
      'loader': Loader,
      'notice-modal': NoticeModal,
      'yesno-modal': YesnoModal,
      'carq-select': CarqSelect,
      'update-button': UpdateButton,
    },

    created: function() {
      this.updateUrl = document.querySelector('#auto-vue').dataset.updateUrl;
    },

    mounted: function() {
      let controledElements = document.querySelectorAll('.js-check-form-saved a');
      for(let i=0; i<controledElements.length; i++){
        controledElements[i].addEventListener('click',this.onExit);
      }
      this.$nextTick(function () {
        $(document).trigger('auto-fully-loaded');
      })
    },

    methods: {
      onExit: function(ev){
        let modified = this.$store.state.auto.changed;
        if(modified) {
          ev.preventDefault();
          this.$store.commit('setYesno', ['Dane zostały zmienione<br>Zapisać do bazy danych?', [this.withUpdateDb, ev.target],[this.withoutUpdateDb, ev.target]]);
        }
      },

      withUpdateDb: async function(el){
        await this.$refs.updbutton.updateDb();
        let url = new URL(el.href);
        if (window.location.pathname == url.pathname) {
          document.location = el.href;
          document.location.reload(true);
        } else {
          window.location = el.href
        }
      },

      withoutUpdateDb: function(el){
        let url = new URL(el.href);
        if (window.location.pathname == url.pathname) {
          document.location = el.href;
          document.location.reload(true);
        } else {
          window.location = el.href
        }
      }
    },
  });
});
